// extracted by mini-css-extract-plugin
export default {"container":"Item_container__HOJH-","topInfo":"Item_topInfo__i8+j6","info":"Item_info__M5Xs5","data":"Item_data__8yyAz","img":"Item_img__TKIpb"};